import { downloadAgreement } from "../../../actions/CarrierAgreementMgmt/Agreements";

import Table from "../../../components/tables/Table";
import { PERMISSIONS } from "../../PermissionsConstants";
export const MassUploadTable = ({
  data,
  columns,
  expandableRowsComponent,
  expandableRowExpanded,
  expandableRowsComponentProps,
  onSelectedRowsChange,
  selectedRows,
  setOpenModal,
  setIsBulkSelected,
  clearSelectedRows,
  isNote,
  loading,
}) => {
  const deletePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_edit;
  const download = (data) => {
    const invalidData = data.filter(
      (d) => !d.condition.toLowerCase().includes("success")
    );

    downloadAgreement(invalidData).then((content) => {
      var url = window.URL.createObjectURL(content.data);

      let tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", "InvalidEntries.xlsx");
      tempLink.click();
    });
  };

  const inValidCount = () => {
    let count = 0;

    data.map((d) => {
      if (!d.condition.toLowerCase().includes("success")) {
        count++;
      }
    });

    return count;
  };

  const validCount = () => {
    let count = 0;

    data?.map((d) => {
      if (d.condition.toLowerCase().includes("success")) {
        count++;
      }
    });

    return count;
  };

  return (
    <div>
      <Table
        columns={columns}
        data={data}
        pagination={true}
        expandableRows={true}
        selectableRows={isNote && data.length > 0 ? true : false}
        expandableRowsComponent={expandableRowsComponent}
        expandableRowExpanded={expandableRowExpanded}
        expandableRowsComponentProps={expandableRowsComponentProps}
        loading={loading}
        onSelectedRowsChange={onSelectedRowsChange}
        selectedRows={selectedRows}
        setOpenModal={setOpenModal}
        setIsBulkSelected={setIsBulkSelected}
        clearSelectedRows={clearSelectedRows}
        deletePermission={deletePermission}
      />
    </div>
  );
};
